import { render } from "./ExportPage.vue?vue&type=template&id=4e5275a0&ts=true"
import script from "./ExportPage.vue?vue&type=script&lang=ts"
export * from "./ExportPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__